<h2>Checkboxes</h2>

<h3>mat-checkbox</h3>
<div class="gap-4">
  @for (
    type of [
      { disabled: false, hover: false },
      { disabled: false, hover: true },
      { disabled: true, hover: false },
    ];
    track type
  ) {
    <div class="row">
      @for (state of [{}, { checked: true }, { indeterminate: true }]; track state) {
        <mat-checkbox
          class="col"
          [checked]="state.checked"
          [indeterminate]="state.indeterminate"
          [disabled]="type.disabled"
          [class.hover]="type.hover"
        >
          Text form option label
        </mat-checkbox>
      }
    </div>
  }
</div>
